// Privacy notice shown on the watch LP (doc §10.2).
const DEFAULT_NOTICE =
  "本ウェビナーでは、申込情報、視聴ページへのアクセス状況、質問内容、クリック、アンケート回答等を取得し、ウェビナー運営、サービス改善、営業・マーケティング活動、フォローアップのために利用します。";

export function PrivacyNotice({ notice }: { notice?: string | null }) {
  return (
    <footer className="privacy-notice">
      <p>{notice?.trim() ? notice : DEFAULT_NOTICE}</p>
      <p>
        投稿いただいた質問は、運営側で確認のうえ、配信画面上で紹介する場合があります。氏名・会社名の表示可否は、質問投稿時の選択内容に従います。
      </p>
    </footer>
  );
}
